import React, { useState } from 'react';
import Field from '../../../../../modules/react/components/stateful/Field';
import SelectInput from '../../../../../modules/react/components/stateful/SelectInput';
import Range from '../../form/inputs/Range/Range';
import Switch from '../../form/inputs/Switch/Switch';
import classes from './section.scss';

const transitionTypes = [
  { value: 'fade', label: 'Fade' },
  { value: 'slide', label: 'Slide' },
  { value: 'zoomin', label: 'Zoom In' },
  { value: 'zoomout', label: 'Zoom Out' },
];

const transitionDirections = [
  { value: 'ltor', label: 'Left To Right' },
  { value: 'rtol', label: 'Right To Left' },
];

const formatTransitionDirection = value => value || 'rtol';
const formatTransitionSpeed = value => value || 0;
const formatSlideDuration = value => value || 0;
const slideDurationMarkers = [
  { value: 0, label: '0s' },
  { value: 1 },
  { value: 2, label: '2s' },
  { value: 3 },
  { value: 4, label: '4s' },
  { value: 5 },
  { value: 6, label: '6s' },
  { value: 7 },
  { value: 8, label: '8s' },
  { value: 9 },
  { value: 10, label: '10s' },
];
const transitionSpeedMarkers = [
  { value: 0, label: '0ms' },
  { value: 100 },
  { value: 200, label: '200ms' },
  { value: 300 },
  { value: 400, label: '400ms' },
  { value: 500 },
  { value: 600, label: '600ms' },
  { value: 700 },
  { value: 800, label: '800ms' },
  { value: 900 },
  { value: 1000, label: '1000ms' },
];

const SlideshowSettingEditor = ({ slideshowSetting }) => {
  const [enableControls, setEnableControls] = useState(
    slideshowSetting?.enableControls || false,
  );
  const [transitionType, setTransitionType] = useState(
    slideshowSetting?.transitionType || transitionTypes[0],
  );

  return (
    <>
      <div className={classes.slideshowSetting}>
        <Field
          component={Switch}
          name="sectionStyle.slideshowSetting.enableControls"
          onChange={() => setEnableControls(!enableControls)}
        />
        <label>Enable Slideshow Controls</label>
      </div>
      <Field
        label="Transition Type"
        labelClassName={classes.fieldLabelClass}
        component={SelectInput}
        name="sectionStyle.slideshowSetting.transitionType"
        clearable={false}
        searchable={false}
        options={transitionTypes}
        className={classes.patternSelect}
        onChange={value => setTransitionType(value)}
        placeholder="Fade"
      />
      {!enableControls && transitionType.value === 'slide' && (
        <Field
          label="Transition Direction"
          labelClassName={classes.fieldLabelClass}
          component={SelectInput}
          name="sectionStyle.slideshowSetting.transitionDirection"
          clearable={false}
          searchable={false}
          format={formatTransitionDirection}
          options={transitionDirections}
          className={classes.patternSelect}
        />
      )}
      <div className={classes.sliderRangeSetting}>
        <Field
          label="Slide Duration(s)"
          labelClassName={classes.fieldLabelClass}
          component={Range}
          name="sectionStyle.slideshowSetting.slideDuration"
          markers={slideDurationMarkers}
          format={formatSlideDuration}
          min={0}
          max={10}
          step={0.1}
        />
        <Field
          label="Transition Speed(ms)"
          labelClassName={classes.fieldLabelClass}
          component={Range}
          name="sectionStyle.slideshowSetting.transitionSpeed"
          format={formatTransitionSpeed}
          markers={transitionSpeedMarkers}
          min={0}
          max={1000}
          step={100}
        />
      </div>
    </>
  );
};

export default SlideshowSettingEditor;
